import { render } from "./setting.vue?vue&type=template&id=2e8e5ef7&scoped=true"
import script from "./setting.vue?vue&type=script&lang=js"
export * from "./setting.vue?vue&type=script&lang=js"

import "./setting.vue?vue&type=style&index=0&id=2e8e5ef7&lang=scss"
import "./setting.vue?vue&type=style&index=1&id=2e8e5ef7&lang=scss&scoped=true"

import exportComponent from "/Users/arvindersingh/Desktop/projects/parsoftwares/rt-backend/backend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e8e5ef7"]])

export default __exports__